import React from 'react';
import styled from 'styled-components';

import { Container } from '../../Hoc/elements';
import StickySidebar from '../../Components/Layout/StickySidebar';
import LeftSection from './LeftSection/LeftSection';
import Main from './AddDemand/Main';
import RightSection from '../Jobs/RightJobSection/RightSection';

const NewDemand = () => (
  <Page>
    <Container>
      <HomeLayout>
        <StickySidebar>
          <LeftSection />
        </StickySidebar>
        <MainSection>
          <Main />
        </MainSection>
        <RankingColumn>
          <RightSection />
        </RankingColumn>
      </HomeLayout>
    </Container>
  </Page>
);

const Page = styled.main`
  width: 100%;
  min-height: calc(100vh - 5rem);
  padding: clamp(1rem, 3vw, 2.5rem) 0 5rem;
  background: var(--color-background);
  color: var(--color-text);
`;

const HomeLayout = styled.div`
  display: grid;
  grid-template-columns: minmax(17rem, 18rem) minmax(0, 1fr);
  align-items: start;
  gap: clamp(1rem, 2vw, 1.5rem);

  /* Rankings are secondary information. They only occupy a third column
     when the viewport is genuinely wide enough for the demand cards. */
  @media (min-width: 94rem) {
    grid-template-columns: minmax(17rem, 18rem) minmax(0, 1fr) minmax(17rem, 18rem);
  }

  /* On compact laptops and tablets the demand workflow gets the full width.
     Account settings remain available from the navigation. */
  @media (max-width: 74rem) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

const MainSection = styled.section`
  min-width: 0;
  align-self: start;
`;

const RankingColumn = styled.div`
  min-width: 0;
  display: none;

  @media (min-width: 94rem) {
    display: block;
  }
`;

export default NewDemand;
